/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PricingDto } from './PricingDto';
import {
    PricingDtoFromJSON,
    PricingDtoFromJSONTyped,
    PricingDtoToJSON,
    PricingDtoToJSONTyped,
} from './PricingDto';

/**
 * A beneficiary (insurer, co-insurer or re-insurer) within a guarantee breakdown
 * @export
 * @interface GuaranteeBeneficiaryDto
 */
export interface GuaranteeBeneficiaryDto {
    /**
     * 
     * @type {string}
     * @memberof GuaranteeBeneficiaryDto
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeBeneficiaryDto
     */
    legalEntityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeBeneficiaryDto
     */
    designation: string;
    /**
     * Quota share percentage
     * @type {number}
     * @memberof GuaranteeBeneficiaryDto
     */
    quotaShareRate: number;
    /**
     * 
     * @type {PricingDto}
     * @memberof GuaranteeBeneficiaryDto
     */
    pricing: PricingDto;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeBeneficiaryDto
     */
    bankAccountId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeBeneficiaryDto
     */
    bankAccountIban?: string | null;
}

/**
 * Check if a given object implements the GuaranteeBeneficiaryDto interface.
 */
export function instanceOfGuaranteeBeneficiaryDto(value: object): value is GuaranteeBeneficiaryDto {
    if (!('designation' in value) || value['designation'] === undefined) return false;
    if (!('quotaShareRate' in value) || value['quotaShareRate'] === undefined) return false;
    if (!('pricing' in value) || value['pricing'] === undefined) return false;
    return true;
}

export function GuaranteeBeneficiaryDtoFromJSON(json: any): GuaranteeBeneficiaryDto {
    return GuaranteeBeneficiaryDtoFromJSONTyped(json, false);
}

export function GuaranteeBeneficiaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuaranteeBeneficiaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'legalEntityId': json['legalEntityId'] == null ? undefined : json['legalEntityId'],
        'designation': json['designation'],
        'quotaShareRate': json['quotaShareRate'],
        'pricing': PricingDtoFromJSON(json['pricing']),
        'bankAccountId': json['bankAccountId'] == null ? undefined : json['bankAccountId'],
        'bankAccountIban': json['bankAccountIban'] == null ? undefined : json['bankAccountIban'],
    };
}

export function GuaranteeBeneficiaryDtoToJSON(json: any): GuaranteeBeneficiaryDto {
    return GuaranteeBeneficiaryDtoToJSONTyped(json, false);
}

export function GuaranteeBeneficiaryDtoToJSONTyped(value?: GuaranteeBeneficiaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'legalEntityId': value['legalEntityId'],
        'designation': value['designation'],
        'quotaShareRate': value['quotaShareRate'],
        'pricing': PricingDtoToJSON(value['pricing']),
        'bankAccountId': value['bankAccountId'],
        'bankAccountIban': value['bankAccountIban'],
    };
}

